import Step from './step';
import {createElement} from 'methods/utils';
import Radio from 'components/radio';

function InitialStep(modal, options = {}) {
    const className = 'InitialStep';
    const $element = createElement(
        `<div class="${className}">
            <div class="${className}__wrapper">
                <form>
                    <div class="${className}__radio-group js-radio-group"></div>
                    <button class="${className}__submit js-submit">Далее</button>
                </form>
            </div>
        </div>`
    );

    Step.call(this, modal, $element, options);

    this.canPrevStep = false;

    this._authPromise = new Promise((resolve, reject) => {
        this._authPromiseResolve = resolve;
        this._authPromiseReject = reject;
    });

    this.$form = this.$element.querySelector('form');
    this.$radioGroup = this.$element.querySelector('.js-radio-group');

    this.$form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit();
    });
    this.$submit = this.$element.querySelector('.js-submit');

    this.radios = this.modal.authTypes.map((authType, index) => {
        const radio = Radio.make({
            name: 'type',
            title: authType.title,
            value: authType.name,
            checked: !index,
        });

        this.$radioGroup.appendChild(radio.$element);

        return radio;
    });

    this.$radioGroup.addEventListener('change', this._onRadioChangeEvent.bind(this));
    this._onRadioChangeEvent();
}

InitialStep.prototype = Object.create(Step.prototype);
Object.defineProperty(InitialStep.prototype, 'constructor', {
    value: InitialStep,
    enumerable: false,
    writable: true,
});

InitialStep.prototype.auth = function() {
    return this._authPromise;
}

InitialStep.prototype.authByType = function(name, data) {
    return this.modal.getAuthTypeByName(name).auth(data);
}

InitialStep.prototype._onRadioChangeEvent = function() {
    this.radios.forEach(radio => {
        radio.$element.classList.toggle('is-checked', radio.checked);
    });
}

InitialStep.prototype.show = function() {
    this.modal.setTitle('Вход или регистрация');
    this.modal.setCanPrevStep(false);
}

InitialStep.prototype.submit = function() {
    const type = this.$form.elements.type.value;

    return this.authByType(type).then((auth) => {
        this._authPromiseResolve(auth);
    }).catch((r) => {
        this._authPromiseReject(type, r);
    });
}

export default InitialStep;
